import Sales from '../services/sales'
import C from '../pages/common/constantes'

const paymentStore = {
  state: {
    currentPlanId: undefined,
    plans: undefined,
    promotionCurrent:undefined,
    whereToDelivrey:undefined,
    confirmCellphone: undefined,
    confirmEmail: undefined
  },
  mutations:{
    currentPlanId(state, planId){
      state.currentPlanId = planId;
    },
    setPlans(state, plans){
      state.plans = plans;
    },
    setPromotion(state, promotion){
      state.promotionCurrent = promotion;
    },
    setwhereToDelivrey(state, code){
      state.whereToDelivrey = code;
    },
    setConfirmCellphone(state, value){
      state.confirmCellphone = value;
    },
    setConfirmEmail(state, value){
      state.confirmEmail = value;
    },
  },
  getters:{
    getReplaceTax: (state, getters) => (planId) => {
      if(!state.plans)
        return "";

      let tax = _.filter(getters.getPlanById(planId).adhesionTax.adhesionTax, (o) => {
        return o.taxId == C.REPLACE_TAXID
      });

      if(tax && tax.length > 0){
        return tax[0].value;
      }

      return undefined;
    },
    getwhereToDelivrey:(state,getters)=>{
      return state.whereToDelivrey;
    },
    getPlanById: (state, getters) => (planId) => {
      if(state.plans === undefined){
        return undefined;
      }
      return state.plans.find(p => p.planId == planId);
    },
    getPromotionCurrent:(state, getters)=>{
      return state.promotionCurrent;
    },
    getNewAdhesionTax: (state, getters) => (planId) => {
      if(!state.plans)
        return "";

      let tax = _.filter(getters.getPlanById(planId).adhesionTax.adhesionTax, (o) => {
        return o.taxId == C.NEW_ADHESION_TAXID
      });

      if(tax && tax.length > 0){
        return tax[0].value;
      }

      return undefined;
    },
    getNewVehicleTax: (state, getters) => (planId) => {
      if(!state.plans)
        return "";

      let tax = _.filter(getters.getPlanById(planId).adhesionTax.adhesionTax, (o) => {
        return o.taxId == C.NEW_VEHICLE_TAXID
      });

      if(tax && tax.length > 0){
        return tax[0].value;
      }

      return undefined;

    },
    getGuaranteeTax: (state, getters) => (planId) => {
      if(!state.plans)
        return "";

      if(planId == 33){
        return _.filter(getters.getPlanById(planId).adhesionTax.adhesionTax, (o) => {
          return o.taxId == C.GUARANTEE_TAXID
        })[0].value;
      } else {
        return 0;
      }
    },
    getLinkRntrcTax: (state, getters) => (planId) => {
      if(!state.plans)
        return "";

      let tax = _.filter(getters.getPlanById(planId).adhesionTax.adhesionTax, (o) => {
        return o.taxId == C.LINK_RNTRC
      });

      if(tax && tax.length > 0){
        return tax[0].value;
      }

      return undefined;

    },
    getMonthlyTax: (state, getters) => (planId) => {
      if(!state.plans)
        return "";

      let tax = _.filter(getters.getPlanById(planId).adhesionTax.adhesionTax, (o) => {
        return o.taxId == C.MONTHLY_TAX
      });

      if(tax && tax.length > 0){
        return tax[0].value;
      }

      return undefined;

    },
    getBankAccountOptions: (state, getters) => (planId) =>  {
      let op = [];
      _.each(getters.getPlanById(planId).paymentMethod.paymentMethod, (o) => {
        if (o.type == 'DC'){
          o.caption = o.name;
          o.value = o.paymentMethodId;
          op.push(o);
        }
      });

      return op;

    },

    getCreditCardOptions: (state, getters) => (planId) =>  {
      let op = [];
      _.each(getters.getPlanById(planId).paymentMethod.paymentMethod, (o) => {
        if (o.type == 'CC'){
          o.caption = o.name;
          o.value = o.paymentMethodId;
          op.push(o);
        }
      });

      return op;

    },

    getBankBillOption: (state, getters) => (planId) =>  {
      let op = undefined;
      _.each(getters.getPlanById(planId).paymentMethod.paymentMethod, (o) => {
        if (o.type == 'BC') {
          op = {
            bankBill: {
              billNumber: o.paymentMethodId
            },
            paymentMethodId: o.paymentMethodId,
            imagePath: o.imagePath,
            billNumber: o.paymentMethodId
          };
        }
      });

      return op;

    },
    getDocOption: (state, getters) => (planId) =>  {
      let op = undefined;
      _.each(getters.getPlanById(planId).paymentMethod.paymentMethod, (o) => {
        if (o.type == 'DO') {
          op = {
            bankBill: {
              billNumber: o.paymentMethodId
            },
            paymentMethodId: o.paymentMethodId,
            imagePath: o.imagePath,
            billNumber: o.paymentMethodId
          };
        }
      });

      return op;

    },
    getTedOption: (state, getters) => (planId) =>  {
      let op = undefined;
      _.each(getters.getPlanById(planId).paymentMethod.paymentMethod, (o) => {
        if (o.type == 'TE') {
          op = {
            bankBill: {
              billNumber: o.paymentMethodId
            },
            paymentMethodId: o.paymentMethodId,
            imagePath: o.imagePath,
            billNumber: o.paymentMethodId
          };
        }
      });

      return op;

    },

    getPaymentsMethodsByPlan: (state, getters) => (planId) => {

      if(state.plans === undefined)
        return undefined;

      if(state.plans.find(p => p.planId == planId) && state.plans.find(p => p.planId == planId).paymentMethod && state.plans.find(p => p.planId == planId).paymentMethod.paymentMethod){

        return state.plans.find(p => p.planId == planId).paymentMethod.paymentMethod;
      }else{
        return undefined;
      }

    },
    getAllPayments(state){
      if(state.plans === undefined)
        return undefined;

      let payments = {};
      state.plans.forEach(o => {
        o.paymentMethod.paymentMethod.forEach(p => {
          payments[p.name] = p;
        });
      });
      return payments;
    },
    getPaymentsTypesByPlan: (state, getters) => (planId) => {
      let obj = {};
      obj.bankBill = !!_.find(getters.getPaymentsMethodsByPlan(planId), o => o.type == "BC");
      obj.bankAccount = !!_.find(getters.getPaymentsMethodsByPlan(planId), o => o.type == "DC");
      obj.creditCard = !!_.find(getters.getPaymentsMethodsByPlan(planId), o => o.type == "CC");
      obj.ted = !!_.find(getters.getPaymentsMethodsByPlan(planId), o => o.type == "TE");
      obj.doc = !!_.find(getters.getPaymentsMethodsByPlan(planId), o => o.type == "DO");
      obj.senff = !!_.find(getters.getPaymentsMethodsByPlan(planId), o => o.type == "SF");

      let i = 0;
      _.forIn(obj, (v) => {

        if(v) i++;
      })
      obj.qtd = i;

      return obj;
    },
    getBankOptionsByPlan: (state, getters) => (planId) => {
      return _.filter(getters.getPaymentsMethodsByPlan(planId), o => o.type == "DC");
    },
    getConfirmCellphone: (state, getters) => () => {
      return state.confirmCellphone;
    },
    getConfirmEmail: (state, getters) => () => {
      return state.confirmEmail;
    }
  },
  actions:{
    actWhereToDelivrey(context,code){
      context.commit('setwhereToDelivrey', code);
    },
    getPlans(context){
      return Sales.getPlan().then(r => {
        context.commit('setPlans', r.plans);
        context.commit('setConfirmCellphone', r.confirmCellphone);
        context.commit('setConfirmEmail', r.confirmEmail);
      }).catch(err => console.log(err));
    },
     getPromotionCode(context, code){
      return Sales.hasPromotion({promotionCode:code}).then(r=>{
        context.commit('setPromotion', r[0]);
        return r[0];
      });
    },

  }
}

export default paymentStore;



// WEBPACK FOOTER //
// ./src/store/sales.js